import {
  WorkflowContainerFullI,
  WorkflowContainerFullActionI,
} from "../../../libs/interfaces";
import { StateCreator } from "zustand";
import { removeImageBlob, saveImageBlob } from "../../../libs/helpers";

const MODULE_ID = "container-full-1";
export const createWorkflowContainerFullSlice: StateCreator<
  WorkflowContainerFullI & WorkflowContainerFullActionI,
  [],
  []
> = (set, get) => ({
  firstTakePhoto: "",
  id: null,
  container: "",
  client: "",
  clientId: null,
  producer: null,
  producerId: null,
  farm: null,
  farmId: null,
  magap: "",
  zone: "",
  balerCode: "",
  brand: null,
  brandId: null,
  box: null,
  boxId: null,
  observation: "",
  producerOptional: null,
  farmOptional: null,
  farmOptionalZone: "",
  balerCodeOptional: "",
  brandOptional: null,
  boxOptional: null,
  magapOptional: null,
  numCajasOptional: null,
  cajasEstibaOptional: null,
  producerOptionalId: null,
  farmOptionalId: null,
  boxOptionalId: null,
  brandOptionalId: null,

  closeProcess: "",
  endLoading: "",
  containerClose: "",
  containerOulet: "",

  adhesivo: "",
  adhesivoBisagra: "",
  adhesivoBisagraPhoto1: "",
  adhesivoBisagraPhoto2: "",
  adhesivoBisagraPhoto3: "",
  adhesivoPhoto: "",
  adhesivoPuerta: "",
  adhesivoPuertaId: null,
  adhesivoPuertaPhoto: "",
  botellaExpor: "",
  botellaExporId: null,
  botellaExporPhoto: "",
  botellaNaviera: "",
  botellaNavieraPhoto: "",
  botellaVerificadoraRastreo: "",
  botellaVerificadoraRastreoPhoto: "",
  cableExpor: "",
  cableExporId: null,
  cableExporPhoto: "",
  cableVerificadora: "",
  cableVerificadoraPhoto: "",
  evaluacionFruta: "",
  evaluacionFrutaPhoto: "",
  guiaTransporte: "",
  guiaTransportePhoto: "",
  numCajas: null,
  cajasEstiba: null,
  numRastreoSatelital: "",
  numRastreoSatelitalPhoto: "",
  siglasFPhoto: "",
  tarjaCarga: "",
  tarjaCargaPhoto: "",
  tarjaCargaPhotoOptional1: "",
  tarjaCargaPhotoOptional2: "",
  termografo: "",
  termografoId: null,
  termografoPhoto: "",
  videoCajas: "",
  videoCierreContenedor: "",
  videoPanelExterior: "",
  statusCF: 0,
  processingVideoC: false,
  processingVideoCC: false,
  processingVideoPE: false,
  cajasConsolidadasPhoto1: "",
  cajasConsolidadasPhoto2: "",
  cajasConsolidadasPhoto3: "",
  cajasConsolidadasPhoto4: "",
  cajasConsolidadasPhoto5: "",
  cierreContenedorPhoto1: "",
  cierreContenedorPhoto2: "",
  cierreContenedorPhoto3: "",
  ventoleraDerechaPhoto: "",
  ventoleraIzquierdaPhoto: "",
  panelIzquierdoPhoto: "",
  panelDerechoPhoto: "",

  calidad: "",
  calidadCi: "",
  gancho: "",
  ganchoCi: "",
  driver: "",
  placa: "",
  companyTransport: "",
  numKit: "",
  producerShort: "",
  farmShort: "",

  setFirstTakePhoto: (firstTakePhoto) => set(() => ({ firstTakePhoto })),
  setProducerOptional: (producerOptional) => set(() => ({ producerOptional })),
  setFarmOptional: (farmOptional) => set(() => ({ farmOptional })),
  setFarmOptionalZone: (farmOptionalZone) => set(() => ({ farmOptionalZone })),
  setBalerCodeOptional: (balerCodeOptional) =>
    set(() => ({ balerCodeOptional })),
  setBoxOptional: (boxOptional) => set(() => ({ boxOptional })),
  setBrandOptional: (brandOptional) => set(() => ({ brandOptional })),
  setMagapOptional: (magapOptional) => set(() => ({ magapOptional })),
  setNumCajasOptional: (numCajasOptional) => set(() => ({ numCajasOptional })),
  setCajasEstibaOptional: (cajasEstibaOptional) =>
    set(() => ({ cajasEstibaOptional })),
  setProducerOptionalId: (producerOptionalId) =>
    set(() => ({ producerOptionalId })),
  setFarmOptionalId: (farmOptionalId) => set(() => ({ farmOptionalId })),
  setBoxOptionalId: (boxOptionalId) => set(() => ({ boxOptionalId })),
  setBrandOptionalId: (brandOptionalId) => set(() => ({ brandOptionalId })),

  setCloseProcess: (closeProcess) => set(() => ({ closeProcess })),
  setEndLoading: (endLoading) => set(() => ({ endLoading })),
  setContainerClose: (containerClose) => set(() => ({ containerClose })),
  setContainerOulet: (containerOulet) => set(() => ({ containerOulet })),

  setContainer: (container) => set(() => ({ container })),
  setClient: (client) => set(() => ({ client })),
  setClientId: (clientId) => set(() => ({ clientId })),
  setProducer: (producer) => set(() => ({ producer })),
  setProducerId: (producerId) => set(() => ({ producerId })),
  setFarm: (farm) => set(() => ({ farm })),
  setFarmId: (farmId) => set(() => ({ farmId })),
  setZone: (zone) => set(() => ({ zone })),
  setBalerCode: (balerCode) => set(() => ({ balerCode })),
  setBox: (box) => set(() => ({ box })),
  setBoxId: (boxId) => set(() => ({ boxId })),
  setBrand: (brand) => set(() => ({ brand })),
  setBrandId: (brandId) => set(() => ({ brandId })),
  setMagap: (magap) => set(() => ({ magap })),
  setId: (id) => set(() => ({ id })),
  setObservation: (observation) => set(() => ({ observation })),
  setCajasEstiba: (cajasEstiba) => set(() => ({ cajasEstiba })),
  setProducerShort: (producerShort) => set(() => ({ producerShort })),
  setFarmShort: (farmShort) => set(() => ({ farmShort })),

  setAdhesivo: (adhesivo) => set(() => ({ adhesivo })),
  setNumKit: (numKit) => set(() => ({ numKit })),
  setAdhesivoBisagra: (adhesivoBisagra) => set(() => ({ adhesivoBisagra })),
  setAdhesivoBisagraPhoto1: async (file) => {
    const getImageBack = get().adhesivoBisagraPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-adhesivoBisagraPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoBisagraPhoto1: photoId }));
  },
  setAdhesivoBisagraPhoto2: async (file) => {
    const getImageBack = get().adhesivoBisagraPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-adhesivoBisagraPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoBisagraPhoto2: photoId }));
  },
  setAdhesivoBisagraPhoto3: async (file) => {
    const getImageBack = get().adhesivoBisagraPhoto3;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-adhesivoBisagraPhoto3-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoBisagraPhoto3: photoId }));
  },
  setAdhesivoPhoto: async (file) => {
    const getImageBack = get().adhesivoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-adhesivoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoPhoto: photoId }));
  },
  setAdhesivoPuerta: (adhesivoPuerta) => set(() => ({ adhesivoPuerta })),
  setAdhesivoPuertaPhoto: async (file) => {
    const getImageBack = get().adhesivoPuertaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-adhesivoPuertaPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoPuertaPhoto: photoId }));
  },
  setBotellaExpor: (botellaExpor) => set(() => ({ botellaExpor })),
  setBotellaExporPhoto: async (file) => {
    const getImageBack = get().botellaExporPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-botellaExporPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ botellaExporPhoto: photoId }));
  },
  setBotellaNaviera: (botellaNaviera) => set(() => ({ botellaNaviera })),
  setBotellaNavieraPhoto: async (file) => {
    const getImageBack = get().botellaNavieraPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-botellaNavieraPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ botellaNavieraPhoto: photoId }));
  },
  setBotellaVerificadoraRastreo: (botellaVerificadoraRastreo) =>
    set(() => ({ botellaVerificadoraRastreo })),
  setBotellaVerificadoraRastreoPhoto: async (file) => {
    const getImageBack = get().botellaVerificadoraRastreoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-botellaVerificadoraRastreoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ botellaVerificadoraRastreoPhoto: photoId }));
  },
  setCableExpor: (cableExpor) => set(() => ({ cableExpor })),
  setCableExporPhoto: async (file) => {
    const getImageBack = get().cableExporPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cableExporPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cableExporPhoto: photoId }));
  },
  setCableVerificadora: (cableVerificadora) =>
    set(() => ({ cableVerificadora })),
  setCableVerificadoraPhoto: async (file) => {
    const getImageBack = get().cableVerificadoraPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cableVerificadoraPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cableVerificadoraPhoto: photoId }));
  },
  setEvaluacionFruta: (evaluacionFruta) => set(() => ({ evaluacionFruta })),
  setEvaluacionFrutaPhoto: async (file) => {
    const getImageBack = get().evaluacionFrutaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-evaluacionFrutaPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ evaluacionFrutaPhoto: photoId }));
  },
  setGuiaTransporte: (guiaTransporte) => set(() => ({ guiaTransporte })),
  setGuiaTransportePhoto: async (file) => {
    const getImageBack = get().guiaTransportePhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-guiaTransportePhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ guiaTransportePhoto: photoId }));
  },
  setNumCajas: (numCajas) => set(() => ({ numCajas })),
  setNumRastreoSatelital: (numRastreoSatelital) =>
    set(() => ({ numRastreoSatelital })),
  setNumRastreoSatelitalPhoto: async (file) => {
    const getImageBack = get().numRastreoSatelitalPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-numRastreoSatelitalPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ numRastreoSatelitalPhoto: photoId }));
  },
  setSiglasFPhoto: async (file) => {
    const ladate = new Date();
    const getImageBack = get().siglasFPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-siglasFPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({
      siglasFPhoto: photoId,
      firstTakePhoto: ladate.toISOString(),
    }));
  },
  setTarjaCarga: (tarjaCarga) => set(() => ({ tarjaCarga })),
  setTarjaCargaPhoto: async (file) => {
    const getImageBack = get().tarjaCargaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-tarjaCargaPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ tarjaCargaPhoto: photoId }));
  },
  setTarjaCargaPhotoOptional1: async (file) => {
    const getImageBack = get().tarjaCargaPhotoOptional1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-tarjaCargaPhotoOptional1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ tarjaCargaPhotoOptional1: photoId }));
  },
  setTarjaCargaPhotoOptional2: async (file) => {
    const getImageBack = get().tarjaCargaPhotoOptional2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-tarjaCargaPhotoOptional2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ tarjaCargaPhotoOptional2: photoId }));
  },
  setTermografo: (termografo) => set(() => ({ termografo })),
  setTermografoPhoto: async (file) => {
    const getImageBack = get().termografoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-termografoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ termografoPhoto: photoId }));
  },
  setCajasConsolidadasPhoto1: async (file) => {
    const getImageBack = get().cajasConsolidadasPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cajasConsolidadasPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cajasConsolidadasPhoto1: photoId }));
  },
  setCajasConsolidadasPhoto2: async (file) => {
    const getImageBack = get().cajasConsolidadasPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cajasConsolidadasPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cajasConsolidadasPhoto2: photoId }));
  },
  setCajasConsolidadasPhoto3: async (file) => {
    const getImageBack = get().cajasConsolidadasPhoto3;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cajasConsolidadasPhoto3-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cajasConsolidadasPhoto3: photoId }));
  },
  setCajasConsolidadasPhoto4: async (file) => {
    const getImageBack = get().cajasConsolidadasPhoto4;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cajasConsolidadasPhoto4-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cajasConsolidadasPhoto4: photoId }));
  },
  setCajasConsolidadasPhoto5: async (file) => {
    const getImageBack = get().cajasConsolidadasPhoto5;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cajasConsolidadasPhoto5-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cajasConsolidadasPhoto5: photoId }));
  },
  setCierreContenedorPhoto1: async (file) => {
    const getImageBack = get().cierreContenedorPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cierreContenedorPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cierreContenedorPhoto1: photoId }));
  },
  setCierreContenedorPhoto2: async (file) => {
    const getImageBack = get().cierreContenedorPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cierreContenedorPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cierreContenedorPhoto2: photoId }));
  },
  setCierreContenedorPhoto3: async (file) => {
    const getImageBack = get().cierreContenedorPhoto3;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cierreContenedorPhoto3-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cierreContenedorPhoto3: photoId }));
  },
  setVentoleraDerechaPhoto: async (file) => {
    const getImageBack = get().ventoleraDerechaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-ventoleraDerechaPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ ventoleraDerechaPhoto: photoId }));
  },
  setVentoleraIzquierdaPhoto: async (file) => {
    const getImageBack = get().ventoleraIzquierdaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-ventoleraIzquierdaPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ ventoleraIzquierdaPhoto: photoId }));
  },
  setPanelIzquierdoPhoto: async (file) => {
    const getImageBack = get().panelIzquierdoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-panelIzquierdoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ panelIzquierdoPhoto: photoId }));
  },
  setPanelDerechoPhoto: async (file) => {
    const getImageBack = get().panelDerechoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-panelDerechoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ panelDerechoPhoto: photoId }));
  },
  setCalidad: (calidad) => set(() => ({ calidad })),
  setCalidadCi: (calidadCi) => set(() => ({ calidadCi })),
  setGancho: (gancho) => set(() => ({ gancho })),
  setGanchoCi: (ganchoCi) => set(() => ({ ganchoCi })),
  setCompanyTransport(companyTransport) {
    set(() => ({ companyTransport }));
  },
  setPlaca(placa) {
    set(() => ({ placa }));
  },
  setDriver(driver) {
    set(() => ({ driver }));
  },
  setVideoCajas: async (file) => {
    if (!file) {
      set(() => ({ videoCajas: "" }));
      return;
    }

    set(() => ({ videoCajas: file }));
  },
  setVideoCierreContenedor: async (file) => {
    if (!file) {
      set(() => ({ videoCierreContenedor: "" }));
      return;
    }

    set(() => ({ videoCierreContenedor: file }));
  },
  setVideoPanelExterior: async (file) => {
    if (!file) {
      set(() => ({ videoPanelExterior: "" }));
      return;
    }

    set(() => ({ videoPanelExterior: file }));
  },
  setProcessingVideoCC: (processingVideoCC) =>
    set(() => ({ processingVideoCC })),
  setProcessingVideoC: (processingVideoC) => set(() => ({ processingVideoC })),
  setProcessingVideoPE: (processingVideoPE) =>
    set(() => ({ processingVideoPE })),
  getDataContainerFull: () => {
    const obj = {
      balerCodeOptional: get().balerCodeOptional,
      magapOptional: get().magapOptional,
      numCajasOptional: get().numCajasOptional,
      cajasEstibaOptional: get().cajasEstibaOptional,
      farmOptionalId: get().farmOptionalId,
      boxOptionalId: get().boxOptionalId,
      brandOptionalId: get().brandOptionalId,
      clientId: get().clientId,
      cajasEstiba: get().cajasEstiba,
      container: get().container,
      producerId: get().producerId,
      producer: get().producer,
      farm: get().farm,
      farmId: get().farmId,
      brandId: get().brandId,
      boxId: get().boxId,
      magap: get().magap,
      balerCode: get().balerCode,
      observation: get().observation,
      closeProcess: get().closeProcess,
      endLoading: get().endLoading,
      containerClose: get().containerClose,
      containerOulet: get().containerOulet,
      numKit: get().numKit,
      adhesivo: get().adhesivo,
      adhesivoBisagra: get().adhesivoBisagra,
      adhesivoBisagraPhoto1: get().adhesivoBisagraPhoto1,
      adhesivoBisagraPhoto2: get().adhesivoBisagraPhoto2,
      adhesivoBisagraPhoto3: get().adhesivoBisagraPhoto3,
      adhesivoPhoto: get().adhesivoPhoto,
      adhesivoPuerta: get().adhesivoPuerta,
      adhesivoPuertaPhoto: get().adhesivoPuertaPhoto,
      botellaExpor: get().botellaExpor,
      botellaExporPhoto: get().botellaExporPhoto,
      botellaNaviera: get().botellaNaviera,
      botellaNavieraPhoto: get().botellaNavieraPhoto,
      botellaVerificadoraRastreo: get().botellaVerificadoraRastreo,
      botellaVerificadoraRastreoPhoto: get().botellaVerificadoraRastreoPhoto,
      cableExpor: get().cableExpor,
      cableExporPhoto: get().cableExporPhoto,
      cableVerificadora: get().cableVerificadora,
      cableVerificadoraPhoto: get().cableVerificadoraPhoto,
      evaluacionFruta: get().evaluacionFruta,
      evaluacionFrutaPhoto: get().evaluacionFrutaPhoto,
      guiaTransporte: get().guiaTransporte,
      guiaTransportePhoto: get().guiaTransportePhoto,
      numCajas: get().numCajas,
      numRastreoSatelital: get().numRastreoSatelital,
      numRastreoSatelitalPhoto: get().numRastreoSatelitalPhoto,
      siglasFPhoto: get().siglasFPhoto,
      tarjaCarga: get().tarjaCarga,
      tarjaCargaPhoto: get().tarjaCargaPhoto,
      tarjaCargaPhotoOptional1: get().tarjaCargaPhotoOptional1,
      tarjaCargaPhotoOptional2: get().tarjaCargaPhotoOptional2,
      termografo: get().termografo,
      termografoPhoto: get().termografoPhoto,
      videoCajas: get().videoCajas,
      videoCierreContenedor: get().videoCierreContenedor,
      videoPanelExterior: get().videoPanelExterior,
      cajasConsolidadasPhoto1: get().cajasConsolidadasPhoto1,
      cajasConsolidadasPhoto2: get().cajasConsolidadasPhoto2,
      cajasConsolidadasPhoto3: get().cajasConsolidadasPhoto3,
      cajasConsolidadasPhoto4: get().cajasConsolidadasPhoto4,
      cajasConsolidadasPhoto5: get().cajasConsolidadasPhoto5,
      cierreContenedorPhoto1: get().cierreContenedorPhoto1,
      cierreContenedorPhoto2: get().cierreContenedorPhoto2,
      cierreContenedorPhoto3: get().cierreContenedorPhoto3,
      ventoleraIzquierdaPhoto: get().ventoleraIzquierdaPhoto,
      ventoleraDerechaPhoto: get().ventoleraDerechaPhoto,
      panelIzquierdoPhoto: get().panelIzquierdoPhoto,
      panelDerechoPhoto: get().panelDerechoPhoto,
      calidad: get().calidad,
      calidadCi: get().calidadCi,
      gancho: get().gancho,
      ganchoCi: get().ganchoCi,
      driver: get().driver,
      placa: get().placa,
      companyTransport: get().companyTransport,
    };

    return obj;
  },
  setDataContainerFull: (ladata) => {
    set(ladata);
    // get().getStatusCF();
  },
  getStatusCF: () => console.log("b"),
  resetClient: () => {
    set(() => ({
      producerId: null,
      producer: null,
      producerShort: null,
      farmId: null,
      farm: null,
      farmShort: null,
      brandId: null,
      brand: null,
      boxId: null,
      box: null,
      balerCode: "",
      zone: "",
      farmOptionalId: null,
      farmOptional: null,
      farmShortOptional: null,
      balerCodeOptional: "",
      farmOptionalZone: "",
    }));
  },
  resetProducer: () => {
    set(() => ({
      farmId: null,
      farm: null,
      farmShort: null,
      balerCode: "",
      zone: "",
    }));
  },

  resetFarm: () => {
    set(() => ({
      farmId: null,
      farm: null,
      farmShort: null,
      balerCode: "",
      zone: "",
    }));
  },

  resetProducerOptional: () => {
    set(() => ({
      farmOptionalId: null,
      farmOptional: null,
      farmShortOptional: null,
      balerCodeOptional: "",
      farmOptionalZone: "",
    }));
  },

  resetFarmOptional: () => {
    set(() => ({
      farmOptionalId: null,
      farmOptional: null,
      farmShortOptional: null,
      balerCodeOptional: "",
      farmOptionalZone: "",
    }));
  },

  getOnlyPhotos: () => {
    const obj = {
      adhesivoBisagraPhoto1: get().adhesivoBisagraPhoto1,
      adhesivoBisagraPhoto2: get().adhesivoBisagraPhoto2,
      adhesivoBisagraPhoto3: get().adhesivoBisagraPhoto3,
      adhesivoPhoto: get().adhesivoPhoto,
      adhesivoPuertaPhoto: get().adhesivoPuertaPhoto,
      botellaExporPhoto: get().botellaExporPhoto,
      botellaNavieraPhoto: get().botellaNavieraPhoto,
      botellaVerificadoraRastreoPhoto: get().botellaVerificadoraRastreoPhoto,
      cableExporPhoto: get().cableExporPhoto,
      cableVerificadoraPhoto: get().cableVerificadoraPhoto,
      evaluacionFrutaPhoto: get().evaluacionFrutaPhoto,
      guiaTransportePhoto: get().guiaTransportePhoto,
      numRastreoSatelitalPhoto: get().numRastreoSatelitalPhoto,
      siglasFPhoto: get().siglasFPhoto,
      tarjaCargaPhoto: get().tarjaCargaPhoto,
      tarjaCargaPhotoOptional1: get().tarjaCargaPhotoOptional1,
      tarjaCargaPhotoOptional2: get().tarjaCargaPhotoOptional2,
      termografoPhoto: get().termografoPhoto,
      cajasConsolidadasPhoto1: get().cajasConsolidadasPhoto1,
      cajasConsolidadasPhoto2: get().cajasConsolidadasPhoto2,
      cajasConsolidadasPhoto3: get().cajasConsolidadasPhoto3,
      cajasConsolidadasPhoto4: get().cajasConsolidadasPhoto4,
      cajasConsolidadasPhoto5: get().cajasConsolidadasPhoto5,
      cierreContenedorPhoto1: get().cierreContenedorPhoto1,
      cierreContenedorPhoto2: get().cierreContenedorPhoto2,
      cierreContenedorPhoto3: get().cierreContenedorPhoto3,
      ventoleraDerechaPhoto: get().ventoleraDerechaPhoto,
      ventoleraIzquierdaPhoto: get().ventoleraIzquierdaPhoto,
      panelIzquierdoPhoto: get().panelIzquierdoPhoto,
      panelDerechoPhoto: get().panelDerechoPhoto,
      videoCajas: get().videoCajas,
      videoCierreContenedor: get().videoCierreContenedor,
    };

    return obj;
  },

  onClear: async () => {
    const state = get();
    const keys = [
      state.adhesivoBisagraPhoto1,
      state.adhesivoBisagraPhoto2,
      state.adhesivoBisagraPhoto3,
      state.adhesivoPhoto,
      state.adhesivoPuertaPhoto,
      state.botellaExporPhoto,
      state.botellaNavieraPhoto,
      state.botellaVerificadoraRastreoPhoto,
      state.cableExporPhoto,
      state.cableVerificadoraPhoto,
      state.evaluacionFrutaPhoto,
      state.guiaTransportePhoto,
      state.numRastreoSatelitalPhoto,
      state.siglasFPhoto,
      state.tarjaCargaPhoto,
      state.tarjaCargaPhotoOptional1,
      state.tarjaCargaPhotoOptional2,
      state.termografoPhoto,
      state.cajasConsolidadasPhoto1,
      state.cajasConsolidadasPhoto2,
      state.cajasConsolidadasPhoto3,
      state.cajasConsolidadasPhoto4,
      state.cajasConsolidadasPhoto5,
      state.cierreContenedorPhoto1,
      state.cierreContenedorPhoto2,
      state.cierreContenedorPhoto3,
      state.ventoleraDerechaPhoto,
      state.ventoleraIzquierdaPhoto,
      state.panelIzquierdoPhoto,
      state.panelDerechoPhoto,
      state.videoCajas,
      state.videoCierreContenedor,
    ];

    for (const key of keys) {
      if (
        key &&
        !key.startsWith("http://") &&
        !key.startsWith("https://") &&
        !key.startsWith("data:")
      ) {
        await removeImageBlob(key);
      }
    }

    set(() => ({
      step: "Formulario",
      firstTakePhoto: "",
      id: null,
      container: "",
      producer: null,
      producerShort: null,
      farmShort: null,
      producerId: null,
      farm: null,
      farmId: null,
      magap: "",
      zone: "",
      balerCode: "",
      brand: null,
      brandId: null,
      box: null,
      boxId: null,
      observation: "",
      producerOptional: null,
      farmOptional: null,
      farmOptionalZone: "",
      balerCodeOptional: "",
      brandOptional: null,
      boxOptional: null,
      magapOptional: null,
      numCajasOptional: null,
      cajasEstibaOptional: null,
      producerOptionalId: null,
      farmOptionalId: null,
      boxOptionalId: null,
      brandOptionalId: null,

      closeProcess: "",
      endLoading: "",
      containerClose: "",
      containerOulet: "",

      numKit: "",
      adhesivo: "",
      adhesivoBisagra: "",
      adhesivoBisagraPhoto1: "",
      adhesivoBisagraPhoto2: "",
      adhesivoBisagraPhoto3: "",
      adhesivoPhoto: "",
      adhesivoPuerta: "",
      adhesivoPuertaId: null,
      adhesivoPuertaPhoto: "",
      botellaExpor: "",
      botellaExporId: null,
      botellaExporPhoto: "",
      botellaNaviera: "",
      botellaNavieraPhoto: "",
      botellaVerificadoraRastreo: "",
      botellaVerificadoraRastreoPhoto: "",
      cableExpor: "",
      cableExporId: null,
      cableExporPhoto: "",
      cableVerificadora: "",
      cableVerificadoraPhoto: "",
      evaluacionFruta: "",
      evaluacionFrutaPhoto: "",
      guiaTransporte: "",
      guiaTransportePhoto: "",
      numCajas: null,
      cajasEstiba: null,
      numRastreoSatelital: "",
      numRastreoSatelitalPhoto: "",
      siglasFPhoto: "",
      tarjaCarga: "",
      tarjaCargaPhoto: "",
      tarjaCargaPhotoOptional1: "",
      tarjaCargaPhotoOptional2: "",
      termografo: "",
      termografoId: null,
      termografoPhoto: "",
      videoCajas: "",
      videoCierreContenedor: "",
      videoPanelExterior: "",
      statusCF: 0,
      cajasConsolidadasPhoto1: "",
      cajasConsolidadasPhoto2: "",
      cajasConsolidadasPhoto3: "",
      cajasConsolidadasPhoto4: "",
      cajasConsolidadasPhoto5: "",
      cierreContenedorPhoto1: "",
      cierreContenedorPhoto2: "",
      cierreContenedorPhoto3: "",
      calidad: "",
      calidadCi: "",
      gancho: "",
      ganchoCi: "",
      driver: "",
      placa: "",
      companyTransport: "",
      ventoleraIzquierdaPhoto: "",
      ventoleraDerechaPhoto: "",
      panelIzquierdoPhoto: "",
      panelDerechoPhoto: "",
    }));
  },
});
